const initialState={}
export const AuthReducer = (state=initialState, { action, payload }) => {
    switch (action) {
        default:return state
    }
}